import { render, staticRenderFns } from "./NotificationConfiguration.vue?vue&type=template&id=0e743bae&scoped=true&"
import script from "./NotificationConfiguration.vue?vue&type=script&lang=js&"
export * from "./NotificationConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e743bae",
  null
  
)

export default component.exports